import { Badge } from '@shared/ui/Badge';
import {
  KADRY_REQUEST_STATUS_LABELS,
  KADRY_REQUEST_STATUS_TONES,
  type KadryProfileStatus,
  type KadryRequestStatus,
} from '@entities/kadry';

export function KadryRequestStatusBadge({
  status,
  justAdded = false,
}: {
  status: KadryRequestStatus;
  /** Заявка из вакансии hh.ru, ещё не запускалась (Р22). */
  justAdded?: boolean;
}) {
  if (justAdded) {
    return (
      <Badge
        $tone="info"
        title="Создана из вакансии hh.ru и стоит на паузе — проверьте карточку поиска и запустите"
      >
        Только что добавлено
      </Badge>
    );
  }
  return <Badge $tone={KADRY_REQUEST_STATUS_TONES[status]}>{KADRY_REQUEST_STATUS_LABELS[status]}</Badge>;
}

export function KadryProfileStatusBadge({ status }: { status: KadryProfileStatus }) {
  return status === 'approved' ? (
    <Badge $tone="success">Утверждена</Badge>
  ) : (
    <Badge $tone="warning">Черновик</Badge>
  );
}
